module.exports = {
      id: "my_account_icon-usage",
      viewBox: "0 0 16 18",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#my_account_icon",
      toString: function () {
        return this.url;
      }
    }